import intercomMethod from './method';

export default function show(message?: string) {
  if (message) {
    intercomMethod('showNewMessage', message);
  } else {
    intercomMethod('show');
  }
}
